import {Component} from '@angular/core';

@Component({
    selector: 'app-register-form-list',

    templateUrl: './register-form-list.component.html',
    styleUrl: './register-form-list.component.css'
})
export class RegisterFormListComponent {

}
